import React from 'react'

import { PayLaterInfo } from '@Domains/Cart/Components/PayLaterInfo/PayLaterInfo'
import { Experiment } from '@Globals/SplitTests/Experiment'

import styles from './PayLater.module.scss'

export const ProductDisplayPayLater = () => (
  <Experiment
    b={(
      <div className={styles.productDisplayPayLater}>
        <PayLaterInfo className={styles.payLaterInfo} />
      </div>
    )}
    test="buy_now_pay_later_v1"
  />
)
